/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTSVG } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { getCSS, getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
import { DropdownFilterSubject } from '../../content/dropdown/DropdownFilterSubject'
import { LanguageHelp } from '../../../helpers/LanguageHelper'

type Props = {
  id?: string
  className: string
  data: ChartsWidgetLineDto[]
  texts?: string[]
  firstColor?: string
  secondColor?: string
  thirdColor?: string
  mainLabel?: string
  sideLabel?: string
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  options?: string[]
  selectedOption?: string
  height?: string
}

function getColor(color: string) {
  return "#" + color;
}

export class ChartsWidgetLineDto { label = -1; firstCount = 0; secondCount = 0; thirdCount = 0 }

const ChartsWidgetLine: React.FC<Props> = ({
  id = '',
  className,
  data,
  texts = ["Net Profit", "Net Profit"],
  firstColor = "47be7d",
  secondColor = "f1416c",
  thirdColor = "e4e6ef",
  mainLabel = "Your Statistics",
  sideLabel = "More than 400 new members",
  functionSubmit,
  functionDownload,
  isDownloadContinue = false,
  options = [],
  selectedOption = LanguageHelp('All'),
  height = "250px"
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  // const [countChart, updateCountChart] = React.useState(0);
  const [previusData, updatePreviusData] = React.useState([new ChartsWidgetLineDto()]);
  const [isChartCreated, updateIsChartCreated] = React.useState(false);
  const [heightInt, updateHeightInt] = React.useState(0);
  const [chartId, updateChartId] = React.useState('id');

  useEffect(() => {
    // if (countChart === data.length)
    //   return

    // updateCountChart(data.length)

    refreshChart()
  })

  const refreshChart = () => {
    if (!chartRef.current) {
      if (data![0].label === -1) {
        updatePreviusData(data)
      }
      return
    }

    if (isChartCreated) {
      if (JSON.stringify(previusData) === JSON.stringify(data)) {
        return
      }
      updatePreviusData(data)
    }

    var element = document.getElementById("apexcharts" + chartId);
    if (typeof (element) != 'undefined' && element != null) {

      const options = getChartOptions(chartId, heightInt, data, texts, firstColor, secondColor, thirdColor)

      ApexCharts.exec(chartId, 'updateOptions', options, true, true);
    } else {
      const chartId = "id" + Math.random().toString(16).slice(2)
      updateChartId(chartId)

      const height = parseInt(getCSS(chartRef.current, 'height'))
      updateHeightInt(height)

      const options = getChartOptions(chartId, heightInt, data, texts, firstColor, secondColor, thirdColor)

      const chart = new ApexCharts(chartRef.current, options)
      chart.render()

      updateIsChartCreated(true)
    }
  }

  return (
    <div className={`card ${className}`}>
      {data![0].label === -1 &&
        <div className='card-header border-0 pt-5'>
          <span className='indicator-progress' style={{ display: 'block' }}>
            {/* Please wait...{' '} */}
            <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
          </span>
          <div className='card-body'>
            {/* begin::Chart */}
            <div style={{ height: height }} />
            {/* end::Chart */}
          </div>
        </div>

      }
      {data![0].label !== -1 &&
        <div>
          <div className='card-header pt-5'>
            {/* begin::Title */}
            <h3 className='card-title d-flex flex-column'>
              <span className='card-label fw-bold text-dark'>{mainLabel}</span>

              <span className='text-muted fw-semibold fs-7'>{sideLabel}</span>
            </h3>
            {/* end::Title */}
            <div className='card-toolbar'>
              <DropdownFilterSubject className='me-2 mb-2' functionSubmit={functionSubmit} options={options} selectedOption={selectedOption} />
              <button
                type='button'
                className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-flip='top-end'
                onClick={(e) => { functionDownload() }}
                disabled={isDownloadContinue}
              >
                {!isDownloadContinue && (
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr044.svg'
                    className='svg-icon-3'
                  />
                )}
                {isDownloadContinue && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
          {/* end::Header */}

          {/* begin::Body */}
          <div className='card-body'>
            {/* begin::Chart */}
            <div ref={chartRef} id='kt_charts_widget_1_chart' style={{ height: height }} />
            {/* end::Chart */}
          </div>
        </div>
      }
      {/* end::Body */}
    </div>
  )
}

export { ChartsWidgetLine }

function getChartOptions(id = 'chartwidgetline', height: number, data?: ChartsWidgetLineDto[], texts = ['Net Profit', 'Revenue'],
  firstColor: string = "47be7d",
  secondColor: string = "f1416c",
  thirdColor: string = "e4e6ef"): ApexOptions {
  const labelColor = getCSSVariableValue('--kt-gray-500')
  const borderColor = getCSSVariableValue('--kt-gray-200')
  let firstArray = []
  let secondArray = []
  let thirdArray = []
  let labelArray = []
  if (texts === undefined) {
    texts = ['Net Profit', 'Revenue']
  }
  if (data) {
    for (let i = 0; i < data!.length; i++) {
      let sentimentByMonth = data![i]
      firstArray.push(sentimentByMonth.firstCount)
      secondArray.push(sentimentByMonth.secondCount)
      thirdArray.push(sentimentByMonth.thirdCount)
      labelArray.push(sentimentByMonth.label)
    }
  }


  return {
    series: [
      {
        name: texts[0],
        data: firstArray,
      },
      {
        name: texts[1],
        data: secondArray,
      },
      {
        name: texts[2],
        data: thirdArray,
      },
    ],
    chart: {
      id: id,
      fontFamily: 'inherit',
      type: 'line',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: labelArray,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return '' + val
        },
      },
    },
    colors: [getColor(firstColor), getColor(secondColor), getColor(thirdColor)],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
